@let savingDrawer = savingDrawer$ | async;
@let newQualificationFromTrainings = newQualificationFromTrainings$ | async;
@let existingQualificationsFromTrainings =
  existingQualificationsFromTrainings$ | async;
@let qualificationsToBeCreatedOrExtendedCount =
  qualificationsToBeCreatedOrExtendedCount$ | async;
<nz-drawer
  [nzVisible]="
    (drawerVisible$ | async) === true &&
    (newQualificationFromTrainings?.length ||
      existingQualificationsFromTrainings?.length)
  "
  [nzMask]="true"
  [nzMaskClosable]="true"
  [nzPlacement]="'right'"
  [nzClosable]="false"
  [nzTitle]="'page.training_qualifications.finalize' | translate"
  [nzSize]="'large'"
  [nzFooter]="drawerFooter"
  (nzOnClose)="closeFinalizeDrawer()"
>
  <ng-container *nzDrawerContent>
    <form nz-form nzLayout="vertical">
      <wilson-training-qualifications-finalize-user-section></wilson-training-qualifications-finalize-user-section>

      @if (newQualificationFromTrainings?.length) {
        <hr />

        <wilson-training-qualifications-finalize-new-qualifications-section
          [newQualificationFromTrainings]="newQualificationFromTrainings"
          [acquiredAtFormControl]="newQualificationsAcquiredAtFormControl"
          [validFromFormControl]="newQualificationsValidFromFromControl"
          [validUntilFormControl]="newQualificationsValidUntilFormControl"
          [infiniteValidFormControl]="newQualificationsInfiniteValidFormControl"
          [confirmedByEmployeeFormControl]="
            newQualificationsConfirmedByEmployeeFormControl
          "
        ></wilson-training-qualifications-finalize-new-qualifications-section>
      }
      @if (existingQualificationsFromTrainings?.length) {
        <hr />

        <wilson-training-qualifications-finalize-extend-existing-qualifications-section
          [existingQualificationFromTrainings]="
            existingQualificationsFromTrainings
          "
          [validUntilFormControl]="existingQualificationsValidUntilFormControl"
          [infiniteValidFormControl]="
            existingQualificationsInfiniteValidFormControl
          "
          [confirmedByEmployeeFormControl]="
            existingQualificationsConfirmedByEmployeeFormControl
          "
        ></wilson-training-qualifications-finalize-extend-existing-qualifications-section>
      }

      <hr />

      <wilson-training-qualifications-finalize-attachments-section
        [(fileList)]="attachmentsList"
        [disabledNzUpload]="savingDrawer"
        [disabledFileList]="savingDrawer"
      ></wilson-training-qualifications-finalize-attachments-section>

      <hr />

      <wilson-training-qualifications-finalize-notes-section
        [notesFormControl]="notesFormControl"
      ></wilson-training-qualifications-finalize-notes-section>
    </form>
  </ng-container>
</nz-drawer>

<ng-template #drawerFooter>
  <wilson-training-qualifications-finalize-footer-section
    (cancelDrawer)="cancelDrawer()"
    (saveDrawer)="
      saveDrawer(
        newQualificationFromTrainings,
        existingQualificationsFromTrainings
      )
    "
    [saveButtonDisabled]="
      isSaveButtonDisabled(
        qualificationsToBeCreatedOrExtendedCount,
        newQualificationFromTrainings,
        existingQualificationsFromTrainings
      )
    "
    [loading]="savingDrawer"
    [qualificationsToBeCreatedOrExtendedCount]="
      qualificationsToBeCreatedOrExtendedCount
    "
  ></wilson-training-qualifications-finalize-footer-section>
</ng-template>
